import React from "react";

function SuccessUpload() {
  return <div>Video Uploaded Successfully</div>;
}

export default SuccessUpload;
